import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { MessageBannerMiddleware } from '@nhl/nhl-react-ui/lib/MessageBanner';

import * as commonReducers from 'media-base-ui/redux/ducks';
import { checkAuthMiddleware, sessionActionTypes } from 'media-base-ui/redux/ducks/session';

import * as reducers from './ducks';

export default function configureStore(initialState) {
    const appReducer = combineReducers({...reducers, ...commonReducers});

    const rootReducer = (state, action) => {
        if (action.type === sessionActionTypes.USER_LOGOUT){
            state = {};
        }

        return appReducer(state, action);
    };

    const storeEnhancer = applyMiddleware(
        thunkMiddleware,
        checkAuthMiddleware,
        MessageBannerMiddleware
    );

    return createStore(
        rootReducer,
        initialState,
        window.__REDUX_DEVTOOLS_EXTENSION__
            ? compose(storeEnhancer, window.__REDUX_DEVTOOLS_EXTENSION__())
            : storeEnhancer
    );
};